import { useContext, useState} from "react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { iconButtonStyles } from "../../../../components/Modal/ModalHeader";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import toastContext from "../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../constants/Constants";
import themeContext from "../../../../context/theme/ThemeContext";
import ResetIcon from "../../../../components/SVGComponents/ResetIcon";
import { t } from "i18next";
import ConfirmModal from "../../../../components/Modal/ConfirmModal";

const ResetReport = ()=>{

    const [showResetReport, setShowResetReport] = useState(false);
    const {disableResetReport, setDisableResetReport, handleModelChange, firstAgenticLLMReport, setUserPrompts, setReportFromAPI, setResetLLMReportClicked } = useContext(studyReportContext);
    const { showToastv2 } = useContext(toastContext);
    const handleReportResetSuccessCloseModal = () =>{
      if(showResetReport){
        setShowResetReport(false);
      }
    }
  
    const handleReportReset = () => {
      setResetLLMReportClicked(true);
      setShowResetReport(false);
      handleModelChange(firstAgenticLLMReport, false);
      setReportFromAPI(firstAgenticLLMReport);
      setUserPrompts(prevPrompts => [{ prompt: t("string-literals.note-old-instructions"), isNote: true }, ...prevPrompts]);
      showToastv2(TOAST_TYPE.SUCCESS, "Report has been reset successfully");
      setDisableResetReport(true);
    }
    const { theme, themeName } = useContext(themeContext);
    return (  
        <CustomToolTipHost 
                    content={"Reset report"} 
                    id="Reset report"
                    tooltipProps={{
                      calloutProps: {
                        styles: {
                          beak: { background: "#252525;" },
                          beakCurtain: { background: "#252525;" },
                          calloutMain: { background: "#252525;" },
                          borderRadius: "20%",
                        },
                      },
                    }}
                  >
                    <div
                        className="highlight-tool"
                        styles={iconButtonStyles}
                        style={{ 
                            cursor: `${!disableResetReport ? 'pointer' : 'not-allowed'}`,
                            marginTop: "2px"
                        }}
                        onClick={() => {if(!disableResetReport) setShowResetReport(true)}}
                    >
                        <ResetIcon color={ theme.palette.inactiveTool }/>
                    </div>
                    {showResetReport && 
                    <ConfirmModal handleConfirm={handleReportReset} handleNotConfirm={handleReportResetSuccessCloseModal} setShowConfirmModal={setShowResetReport} showConfirmModal={showResetReport} message={t("confirm-message.reset-report-confirmation")}
                    title={t("confirm-message.confirm-reset-report")} confirmButtonText={t("confirm-message.yes")} cancelButtonText={"Cancel"}/>
                  }
                  </CustomToolTipHost>
               
    );                 
};

export default ResetReport;